import trainingsHub from "@/views/workouts/v2/trainingsHub.vue"

export default [
  {
    path: "/workouts/hub",
    name: "Workouts_v2",
    component: trainingsHub,
    meta: { navbarTitle: "Deine Workouts", hideBottomNavigation: true, fullWidth: true },
  },
]
